// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".font-weight-normal[data-v-51e27d99]{font-weight:normal}", "",{"version":3,"sources":["webpack://./src/main/webapp/WEB-INF/views/common/components/ob1/AlertMessage.vue"],"names":[],"mappings":"AACA,qCACI,kBAAA","sourcesContent":["\n.font-weight-normal {\n    font-weight: normal;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
